/** 登录后连接全局 live-feed，供首页爆奖及后续实时能力共用 */
export default defineNuxtPlugin(() => {
  startLiveFeed()
})
